import { AccessorsMutatorsDecorator } from "../../helpers";
import { TranslatableModel } from "./translatable-model";
import { NumberFormat } from './number-format.model';
import { Property } from './property.model';

/**
 * @class Item
 * @property {number} id
 * @property {string} name
 */
export class Item extends TranslatableModel {

    /**
     * @type {string[]}
     */
    static get translatableAttributes() {
        
        return [ 'name', 'description' ];
    }
    
    static get validationModel() {
        
        return {
            name: {
                label: 'ITEM_NAME_IN_ENGLISH',
                commonLabel: 'Item name'
            },
            name_ar: {
                label: 'ITEM_NAME_IN_ARABIC',
                commonLabel: 'Item name'
            },
            type: {
                label: 'ITEM_TYPE'
            },
            code: {
                label: 'ITEM_CODE'
            },
            current_stock_quantity: {
               label: 'CURRENT_STOCK_QUANTITY',
               messages: {
                   number: 'THE_VALUE_MUST_BE_NUMBER'
               }
            },
            reorder_threshold_quantity: {
                label: 'REORDER_THRESHOLD_QUANITY',
                messages: {
                    lowerThan: 'THIS_VALUE_MUST_BE_LOWER_THAN_CURRENT_STOCK_QUANTITY',
                    number: 'THE_VALUE_MUST_BE_NUMBER'
                }
            },
            remaining_quantity: {
                label: 'REMAINING_QUANITY',
                messages: {
                    lowerThan: 'THIS_VALUE_MUST_BE_LOWER_THAN_CURRENT_STOCK_QUANTITY',
                    number: 'THE_VALUE_MUST_BE_NUMBER'
                }
            }
        };
    }

    /**
     * @param {Object|Property} value
     * @returns {Property}
     */
    setProperty(value) {
        
        return value instanceof Property ? value : new Property(value);
    }

    formatPrice(value = this.price) {
        
        if (!value) {
            
            return value;
        }
        
        const formatType = this.property.general_settings.currency_format;
        const currency = this.constructor.$rootScope.$lang !== 'en' ? this.property.general_settings.currency.name_ar : this.property.general_settings.currency.name;
        
        return this.constructor.$sce.trustAsHtml(`${NumberFormat.format(value, formatType)} ${currency}`);
    }
    
    canBeSold() {
        
        return this.track_stock_inventory == 0 || this.stop_selling == 0 || this.current_stock_quantity > this.remaining_quantity;
    }

    outOfStock() {

        return this.track_stock_inventory === 1 && this.current_stock_quantity <= 0;
    }
}

AccessorsMutatorsDecorator('id', ...Item.translatableAttributesWithLanguageAliases, 'property_id', 'item_category_id',
    'property', 'item_category', 'type', 'status', 'sku', 'code', 'notes_required', 'price', 'no_price', 'track_stock_inventory',
    'current_stock_quantity', 'reorder_threshold_quantity', 'stop_selling', 'remaining_quantity', 'order', 'taxes_fees',
    'addons', 'expense_type_id', 'can_change_price')(Item);



// WEBPACK FOOTER //
// ./src/pms-api/models/item.model.js